module.exports = __webpack_public_path__ + "static/upd-5b4bd9dc4f5be58853aa1e376be02315.png";